class PhotoViewer {
    constructor(picture) {
        this.picture = $(picture);
        this.src = this.picture.data('full-src');
        this.picture.on('click', this.onPictureClick.bind(this));
        this.tags = this.picture.data('tags');
        let img = this.picture.find('img');

        this.compareButton = this.picture.next('.compare-button').on('click', this.onCompareClick.bind(this));
        if (this.compareButton) {
            this.srcPast = this.compareButton.data('src-past');
            this.srcPresent = this.compareButton.data('src-present');
        }

        if (img[0].complete) {
            this.showThumbTags();
        } else {
            img.on('load', this.onPictureLoaded.bind(this));
            let width = img.data('width');
            let height = img.data('height');
            this.loadingPictureWrapper = $('<div class="loader"/>').insertAfter(this.picture);
            this.loadingPicture = $('<svg width="' + width + '" height="' + height + '" viewBox="0 0 ' + width + ' ' + height + '" xmlns="http://www.w3.org/2000/svg"/>').appendTo(this.loadingPictureWrapper);
            this.picture.remove();
        }
    }
    appear(compare) {
        if (this.showPhotoTimer) clearTimeout(this.showPhotoTimer);
        if (this.hidePhotoTimer) clearTimeout(this.hidePhotoTimer);
        this.showPhotoTimer = setTimeout(function() {
            this.container.addClass('visible');
            this.picture.addClass('viewing');
            if (this.compareButton && this.compareButton.length > 0) {
                if (compare) this.compareToggle.appendTo(document.body);
                else this.compareActivator.appendTo(document.body);
            }
        }.bind(this), 100);
    }
    activate(compare) {
        if (PhotoViewer.active === this) return;
        if (PhotoViewer.active) PhotoViewer.active.deactivate();
        PhotoViewer.active = this;

        this.picture.removeClass('fade-in')

        PhotoViewer.showOverlay();
        $('#content').attr('aria-hidden', 'true');
        this.container.attr('aria-modal', 'true');

        var photoRect = this.picture[0].getBoundingClientRect();
        this.container.removeClass('closed offscreen').appendTo(document.body);
        this.container.css({
            left: photoRect.x + photoRect.width / 2,
            top: photoRect.y + photoRect.height / 2,
            width: photoRect.width,
            height: photoRect.height
        });

        if (this.tempPicture) this.tempPicture.remove();
        if (compare) {
            this.imgWrapper.remove();
            this.compareWrapper.appendTo(this.container);
            if (this.pastImg[0].complete && this.presentImg[0].complete) {
                this.appear(true);
            } else {
                this.container.addClass('waiting');
                this.pastImg.one('load', this.onCompareImageLoaded.bind(this));
                this.presentImg.one('load', this.onCompareImageLoaded.bind(this));
            }
            this.tempPicture = this.picture.clone().addClass('temp').prependTo(this.compareWrapper);
        } else {
            this.imgWrapper.appendTo(this.container);
            this.compareWrapper.remove();
            if (this.img[0].complete) {
                this.appear();
            } else {
                this.container.addClass('waiting');
                this.img.one('load', this.onFullImageLoaded.bind(this));
                this.tempPicture = this.picture.clone().addClass('temp').prependTo(this.imgWrapper);
            }
        }

        $(document).on('keydown', PhotoViewer.onKeyDown);
    }
    deactivate() {
        if (PhotoViewer.active === this) PhotoViewer.active = null;

        PhotoViewer.hideOverlay();
        $('#content').removeAttr('aria-hidden');
        this.container.removeAttr('aria-modal');

        this.container.removeClass('visible').addClass('closed');
        if (this.picture.closest('.navigation-wrapper').hasClass('out')) {
            this.container.addClass('offscreen');
        } else {
            var photoRect = this.picture[0].getBoundingClientRect();
            this.container.css({
                left: photoRect.left + photoRect.width / 2,
                top: photoRect.top + photoRect.height / 2,
                width: photoRect.width,
                height: photoRect.height
            });
        }

        if (this.showPhotoTimer) clearTimeout(this.showPhotoTimer);
        if (this.hidePhotoTimer) clearTimeout(this.hidePhotoTimer);
        this.hidePhotoTimer = setTimeout(function() {
            this.container.remove();
            this.compareToggle.remove();
            this.compareActivator.remove();
            this.picture.removeClass('viewing');
            this.container.css({
                left: null,
                top: null,
                width: null,
                height: null
            });
            if (this._pastHoverImg) this._pastHoverImg.removeClass('moved');
            if (this._presentHoverImg) this._presentHoverImg.removeClass('moved');
        }.bind(this), 300);

        $(document).off('keydown', PhotoViewer.onKeyDown);
    }
    showThumbTags() {
        if (this.tags) {
            let wrap = this.picture.closest('.photo-container').find('.wrap');
            for (let tag of this.tags) {
                let tagDiv = $('<div class="tag"/>').text(tag.title).appendTo(wrap);
                tagDiv.css({
                    left: (tag.x + tag.w / 2) + '%',
                    top: (tag.y + tag.h / 2) + '%'
                }).addClass(tag.x < 50 ? 'left' : 'right');
                tagDiv.on('click', this.onTagClick.bind(this, tag));
            }
        }
    }
    get container() {
        if (!this._container) {
            this._container = $('<div class="photo-viewer"/>');
            this.imgWrapper = $('<div class="image-wrapper"/>').on('click', PhotoViewer.onContentClick);
            this.compareWrapper = $('<div class="compare-wrapper"/>').on('click', PhotoViewer.onContentClick);
            this._container.on('click', PhotoViewer.onOverlayClick);
            this._container.on('wheel mousewheel DOMMouseScroll', PhotoViewer.onContentWheel);
            for (let tag of this.tags) {
                let tagDiv = $('<div class="tag"/>').text(tag.title).appendTo(this.imgWrapper);
                tagDiv.css({
                    left: (tag.x + tag.w / 2) + '%',
                    top: (tag.y + tag.h / 2) + '%'
                }).addClass(tag.x < 50 ? 'left' : 'right');
                tagDiv.on('click', this.onTagClick.bind(this, tag));
            }
            this.compareToggle = $('<div class="compare-toggle"/>').on('click', this.onCompareToggle.bind(this));
            $('<div class="toggle past"/>').text('Verleden').appendTo(this.compareToggle);
            $('<div class="toggle present"/>').text('Heden').appendTo(this.compareToggle);
            this.compareActivator = $('<div class="compare-activator"/>').text('Vergelijk met heden').on('click', this.onCompareActivate.bind(this));
        }
        return this._container;
    }
    get img() {
        if (!this._img) {
            this._img = $('<img class="viewer-image"/>').attr('src', this.src).appendTo(this.imgWrapper);
        }
        return this._img;
    }
    get pastImg() {
        if (!this._pastImg) {
            this._pastImg = $('<img class="viewer-image past"/>').attr('src', this.srcPast).appendTo(this.compareWrapper);
            this._pastHoverImg = $('<div class="hover-image past"/>').css('background-image', 'url(' + this.srcPast + ')').appendTo(this.compareWrapper);
            this._pastHoverImg.on('mousemove', this.onMoveHover.bind(this, this._pastHoverImg));
        }
        return this._pastImg;
    }
    get presentImg() {
        if (!this._presentImg) {
            this._presentImg = $('<img class="overlay-image present"/>').attr('src', this.srcPresent).appendTo(this.compareWrapper);
            this._presentHoverImg = $('<div class="hover-image present"/>').css('background-image', 'url(' + this.srcPresent + ')').appendTo(this.compareWrapper);
            this._presentHoverImg.on('mousemove', this.onMoveHover.bind(this, this._presentHoverImg));
        }
        return this._presentImg;
    }
    onCompareClick() {
        this.activate(true);
    }
    onCompareToggle(event) {
        const present = !this.compareToggle.hasClass('present');
        this.compareToggle.toggleClass('present', present);
        this.compareWrapper.toggleClass('present', present);
        event.preventDefault();
        event.stopPropagation();
    }
    onCompareActivate() {
        this.container.addClass('transitioning');
        if (this.hidePhotoTimer) clearTimeout(this.hidePhotoTimer);
        let complete = this.pastImg[0].complete && this.presentImg[0].complete
        let viewer = this
        this.hidePhotoTimer = setTimeout(function() {
            let appear = function() {
                viewer.container.removeClass('transitioning');
            }
            viewer.compareToggle.appendTo(document.body);
            viewer.compareActivator.remove();
            viewer.imgWrapper.remove();
            viewer.compareWrapper.appendTo(viewer.container);
            if (this.tempPicture) viewer.tempPicture.remove();
            viewer.tempPicture = viewer.picture.clone().addClass('temp').prependTo(viewer.compareWrapper);
            if (viewer.pastImg[0].complete && viewer.presentImg[0].complete) {
                appear();
            } else {
                viewer.pastImg.one('load', appear);
                viewer.presentImg.one('load', appear);
            }
        }, 300);
    }
    onMoveHover(image, event) {
        image.addClass('moved');
        const rect = image[0].getBoundingClientRect();
        const size = Math.min(rect.width, rect.height) / 3;
        const left = event.clientX - rect.left;
        const top = event.clientY - rect.top;
        const mask = 'radial-gradient(circle at ' + left + 'px ' + top + 'px, #000 ' + Math.round(size / 2) + 'px, rgba(0,0,0,0) ' + Math.round(size) + 'px)';
        image.css('-webkit-mask-image', mask).css('mask-image', mask);
    }
    onTagClick(tag) {
        Navigation.push({
            url: tag.url,
            searchTerm: tag.title,
            title: tag.title
        });
        if (PhotoViewer.active) PhotoViewer.active.deactivate();
    }
    onPictureLoaded() {
        if (this.loadingPictureWrapper) {
            this.picture.addClass('fade-in').insertAfter(this.loadingPictureWrapper);
            this.loadingPictureWrapper.remove();
            this.loadingPictureWrapper = null;
            this.loadingPicture = null;
        }
        this.showThumbTags();
    }
    onFullImageLoaded() {
        this.container.removeClass('waiting');
        if (this.tempPicture) this.tempPicture.remove();
        this.appear();
    }
    onCompareImageLoaded() {
        if (this.pastImg[0].complete && this.presentImg[0].complete) {
            this.container.removeClass('waiting');
            this.appear(true);
        }
    }
    onPictureClick() {
        if ($(window).width() >= 1000) this.activate();
    }

    static getOverlay() {
        if (!PhotoViewer._overlay) {
            PhotoViewer._overlay = $('<div id="viewer-overlay"/>');
            PhotoViewer._overlay.on('click', PhotoViewer.onOverlayClick);
            PhotoViewer._overlay.on('wheel mousewheel DOMMouseScroll', PhotoViewer.onContentWheel);
            PhotoViewer.closeButton = $('<button type="button" id="close-viewer"/>');
            PhotoViewer.closeButton.on('click', PhotoViewer.onOverlayClick);
        }
        return PhotoViewer._overlay;
    }

    static showOverlay() {
        if (PhotoViewer.showOverlayTimer) clearTimeout(PhotoViewer.showOverlayTimer);
        if (PhotoViewer.hideOverlayTimer) clearTimeout(PhotoViewer.hideOverlayTimer);
        PhotoViewer.showOverlayTimer = setTimeout(function() {
            PhotoViewer.getOverlay().removeClass('closed offscreen').appendTo(document.body);
            PhotoViewer.closeButton.appendTo(document.body);
        }, 100);
    }

    static hideOverlay() {
        PhotoViewer.getOverlay().addClass('closed');
        if (PhotoViewer.showOverlayTimer) clearTimeout(PhotoViewer.showOverlayTimer);
        if (PhotoViewer.hideOverlayTimer) clearTimeout(PhotoViewer.hideOverlayTimer);
        PhotoViewer.hideOverlayTimer = setTimeout(function(){
            PhotoViewer.getOverlay().remove();
            PhotoViewer.closeButton.remove();
        }, 300);
    }

    static onKeyDown(event) {
        switch (event.key) {
            case $.key.escape:
                if (PhotoViewer.active) PhotoViewer.active.deactivate();
                break;
            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
    }

    static onOverlayClick() {
        if (PhotoViewer.active) PhotoViewer.active.deactivate();
    }

    static onContentWheel(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    static onContentClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    static onContentAdded(event, content) {
        $(content).find('picture[data-full-src]').each(function () {
            new PhotoViewer(this);
        })
    }
}

$(document).on('contentAdded', PhotoViewer.onContentAdded);
